import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconMacbookAir: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconMacbookAir"><Path d="M21.5 15.5V4.5H2.5V15.5M1.5 17.5V18.5C1.5 19.0523 1.94772 19.5 2.5 19.5H21.5C22.0523 19.5 22.5 19.0523 22.5 18.5V17.5H15L14 18H10L9 17.5H1.5Z" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconMacbookAir;
